$(() => {
  $('a[href^="#"].smooth-scroll').click((event) => {
    event.preventDefault();
    $('html').animate({ scrollTop: $(event.target.hash).offset().top }, 500);
  });
});
